const axios = require("axios");
const get = require("lodash/get");
const returnJsonOrError = require("./returnJsonOrError");
const { color } = require("./log-colors");

const returnData = (res) => {
  const url = get(res, "config.url", "unknown");

  if (res.status === 204) {
    console.warn(
      color.yellow(`GET ${url} returned 204 No Content — the resource exists but has no data`),
    );
  }
  if (res.status > 204) {
    const msg = `GET ${url} failed — status ${res.status} (${res.statusText || "no status text"})`;
    console.error(color.red(msg));
    throw Error(msg);
  }

  return res.data;
};

module.exports.get = (url, headers) => {
  const printError = (error) =>
    console.error(
      color.red(`GET ${url} Failed to get a response from server, headers: ${
        headers ? headers : "None"
      }, error: ${error}`),
    );
  if (headers) {
    return axios
      .get(url, { headers })
      .then(returnData)
      .catch((error) => {
        printError(error);
        throw error;
      });
  } else {
    return axios
      .get(url)
      .then(returnData)
      .catch((error) => {
        printError(error);
        throw error;
      });
  }
};

module.exports.post = (url, payload, headers) =>
  fetch(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...headers,
    },
    method: "POST",
    body: JSON.stringify(payload),
  })
    .then(returnJsonOrError)
    .catch((error) => {
      console.error(color.red(`POST ${url}, Failed, ${error}`));
      throw "Error - failed to fetch";
    });

module.exports.deleteMethod = (url, headers) =>
  fetch(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...headers,
    },
    method: "DELETE",
  })
    .then(returnJsonOrError)
    .catch((error) => {
      console.error(color.red(`DELETE ${url}, Failed, ${error}`));
      throw "Error - failed to fetch";
    });
